var classof = require(48);
var ITERATOR = require(122)('iterator');
var Iterators = require(79);
module.exports = require(53).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
